import React, {Component} from "react";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import {fetchDataAsync} from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import * as R from "ramda";
import {HttpStatus} from "../../../../../common/Constants";
import FakturJualDetailDataInput from "../fakturJualDetailDataInput";
import {config} from "../../config";
import { isOlderThanOldestUnit } from "../violationRules";

class TabDataUnit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            detailInputDataVisible: false,
            oldestUnitVisible: false,
            variantOptions: [],
            warnaOptions: [],
            data: {
                kodeVariant: null,
                namaVariant: null,
                tipe: null,
                series: null,
                namaWarnaKomersil: null,
            }
        }
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllVariant,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: "",
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            const ddl = await res.data.data.map((item) => {
                mapToObjectDDL(item.namaVariant, item.kodeVariant);
                return {
                    label: item.kodeVariant,
                    value: item.namaVariant,
                    idType: item.idType,
                };
            });
            this.setState((prevState) => ({
                ...prevState,
                variantOptions: ddl,
            }));

            const selectedColor = ddl.find(
                (item) => item.label === this.getValue("kodeVariant")?.value
            );

            if (this.getValue("kodeVariant")?.value) {
                this.handleVarianChange(
                    this.props.tab,
                    "kodeVariant",
                    selectedColor,
                    true
                );
            }
        }

        this.handleTriggerLoading();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const prevKodeVarian = prevProps.data?.dataUnit?.kodeVariant?.value;
        const currKodeVarian = this.props.data?.dataUnit?.kodeVariant?.value;
        if (prevKodeVarian !== currKodeVarian) {
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPackage: {
                        ...prevState.data.dataPackage,
                        selectedPackage: null,
                        dataTable: {
                            ksu: [],
                            hadiah: [],
                            barangLain: [],
                            part: [],
                        },
                    },
                    dataTransaction: {
                        ...prevState.data.dataTransaction,
                        detailTransaction: {
                            ...prevState.data.dataTransaction.detailTransaction,
                            pembayaranUnit: {
                                ...prevState.data.dataTransaction.detailTransaction.pembayaranUnit,
                                salesProgramId: null,
                            }
                        }
                    }
                }
            }))
        }
        if(prevState.oldestUnitVisible !== this.state.oldestUnitVisible){
            this.props.handlePelanggaran(
              this.state.oldestUnitVisible,
              "APPRV0016"
            );
        }
    }

    handleDetailInputDataVisible = () => {
        const kodeVariant = this.props.data?.dataUnit?.kodeVariant;
        const idWarna = this.props.data?.dataUnit?.idWarna;
        if (kodeVariant && idWarna) {
            this.setState((prevState) => ({
                ...prevState,
                detailInputDataVisible: !prevState.detailInputDataVisible
            }));
        }
    }

    handleSelectInputData = async (value, _, oldestUnit) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getTypeById,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: value?.idType,
        });

        let type = "";
        let series = "";

        if (res.ok) {
            type = res.data.data?.typeName;
            series = res.data.data?.seriesDTO?.seriesName;
        }

        let dataUnit = {
            idWarna: mapToObjectDDL(value.kodeWarna, value.idWarna),
            kodeVariant: mapToObjectDDL(value.kodeVariant, value.kodeVariant),
            nomorMesin: value.nomorMesin,
            nomorRangka: value.nomorRangka,
            tipe: type,
            series: series,
        }

        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataUnit: {
                    ...prevState.data.dataUnit,
                    ...dataUnit
                }
            }
        }));

        const oldestUnitVisible = isOlderThanOldestUnit(
            value.usia,
            oldestUnit?.umur
        );
        this.setState((prevState) => ({...prevState, oldestUnitVisible}))
        this.handleDetailInputDataVisible();
    }

    handleVarianChange = async (tab, name, value, skipResetKodeWarna) => {
        let warnaOptions = [];
        let type = "";
        let series = "";
        if (!R.isNil(value)) {
            const res = await Promise.all([
                Api.create("NAGAMAS_MASTER_DATA").getAllWarnaByParam({paramFilters: {kodeVariant: value?.label}}),
                Api.create("NAGAMAS_MASTER_DATA").getTypeById(value?.idType),
            ]);

            if (res[0].ok && res[0]?.data?.status === HttpStatus.SUCCESS && !R.isEmpty(res[0]?.data?.data)) {
                warnaOptions = res[0].data.data.map(
                    (item) => {
                        mapToObjectDDL(item.namaWarnaKomersil, item.id)
                        return {
                            label: item.kodeWarna,
                            value: item.id,
                            namaWarnaKomersil: item.namaWarnaKomersil
                        }
                    }
                );
            }

            if (res[1].ok && res[1]?.data?.status === HttpStatus.SUCCESS && !R.isEmpty(res[1]?.data?.data)) {
                type = res[1].data.data.typeName;
                series = res[1].data.data.seriesDTO.seriesName;
            }
        }

        if (!skipResetKodeWarna) {
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    dataUnit: {
                        ...prevState.data.dataUnit,
                        kodeVariant: value,
                        namaVariant: value?.value,
                        tipe: type,
                        series: series,
                        idWarna: null,
                        namaWarnaKomersil: null,
                        nomorRangka: null,
                        nomorMesin: null,
                    },
                },
            }));
        }

        this.setState((prevState) => ({
            ...prevState,
            warnaOptions: warnaOptions,
            oldestUnitVisible: false,
        }));
    }

    handleWarnaChange = (tab, name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataUnit: {
                    ...prevState.data.dataUnit,
                    idWarna: value,
                    namaWarnaKomersil: value?.namaWarnaKomersil,
                    nomorRangka: null,
                    nomorMesin: null,
                }
            }
        }))

        this.setState((prevState) => ({
            ...prevState,
            oldestUnitVisible: false,
        }));
    }

    getValue = (key) => {
        const {tab} = this.props
        return this.props.data[tab]?.[key] || null;
    }

    getValueError = (key) => {
        const {tab} = this.props
        return this.props.errors[tab]?.[key] || null;
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    setValue = (name, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                dataUnit: {
                    ...prevState.data.dataUnit,
                    [name]: value
                }
            }
        }))
    }

    render() {
        const {tab} = this.props
        return (
            <>
                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <div className="margin-5px">
                            <div className="txt-site txt-16 txt-main txt-bold">
                                <h4>Info Unit</h4>
                            </div>
                        </div>
                        <SimpleDDL
                            id="select_options_kode_varian"
                            name="kodeVariant"
                            label="Kode Varian"
                            box="search"
                            mandatory
                            isClearable
                            options={this.state.variantOptions}
                            readOnly={!this.props.state.isEditable}
                            errorMessage={this.getValueError("kodeVariant")}
                            value={this.getValue("kodeVariant")}
                            onChange={(value, {name}) => this.handleVarianChange(tab, name, value)}
                        />
                        <SimpleInput
                            id="input_text_nama_varian"
                            name="namaVariant"
                            label="Nama Varian"
                            readOnly
                            value={this.getValue("namaVariant")}
                        />
                        <SimpleInput
                            id="input_text_tipe"
                            name="tipe"
                            label="Tipe"
                            readOnly
                            value={this.getValue("tipe")}
                        />
                        <SimpleInput
                            id="input_text_series"
                            name="series"
                            label="Series"
                            readOnly
                            value={this.getValue("series")}
                        />
                        <SimpleDDL
                            id="select_options_kode_warna"
                            name="idWarna"
                            label="Kode Warna"
                            box="search"
                            mandatory
                            isClearable
                            options={this.state.warnaOptions}
                            readOnly={!this.props.state.isEditable}
                            errorMessage={this.getValueError("idWarna")}
                            value={this.getValue("idWarna")}
                            onChange={(value, {name}) => this.handleWarnaChange(tab, name, value)}
                        />
                        <SimpleInput
                            id="input_text_nama_warna"
                            name="namaWarnaKomersil"
                            label="Nama Warna"
                            readOnly
                            value={this.getValue("namaWarnaKomersil")}
                        />
                    </div>
                    <div id="grid-2">
                        <div className="margin-5px">
                            <div className="txt-site txt-12 txt-main txt-bold">
                                <h4>Pilih No. Mesin / No. Rangka</h4>
                            </div>
                        </div>
                        <SimpleButton
                            text="Cek Ketersediaan"
                            styles={{width: "80%"}}
                            className="margin-left-none"
                            disabled={!this.props.state.isEditable}
                            onClick={this.handleDetailInputDataVisible}
                        />
                        <SimpleInput
                            id="input_text_nomor_mesin"
                            name="nomorMesin"
                            label="Nomor Mesin"
                            mandatory
                            readOnly
                            value={this.getValue("nomorMesin") || null}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                            errorMessage={this.props.errors?.dataUnit?.nomorMesin}
                        />
                        <SimpleInput
                            id="input_text_nomor_rangka"
                            name="nomorRangka"
                            label="Nomor Rangka"
                            mandatory
                            readOnly
                            value={this.getValue("nomorRangka")}
                            onChange={({target}) => this.setValue(target.name, target.value)}
                            errorMessage={this.props.errors?.dataUnit?.nomorRangka}
                        />

                        {this.state.oldestUnitVisible && (
                            <div className="margin-5px">
                                <div className="txt-site txt-11 txt-main txt-bold">
                                    <p><span
                                        style={{color: "red"}}>ada unit dengan usia lebih lama - perlu approval</span>
                                    </p>
                                </div>
                            </div>
                        )}

                    </div>
                </div>
                {this.state.detailInputDataVisible && (
                    <FakturJualDetailDataInput
                        visible={this.state.detailInputDataVisible}
                        {...this.props}
                        title="List Data No. Rangka / No. Mesin"
                        type="NokaNosin"
                        tableColumns={config.tableColumnDataNokaNosin}
                        onSelect={this.handleSelectInputData}
                        onClickClose={this.handleDetailInputDataVisible}
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(TabDataUnit);
